import React from 'react';
import { MorphologyStore } from '../MorphologyStore';

type InputSquareProps = {
  clueIndex: number;
  letterIndex: number;
};

const InputSquare = ({ clueIndex, letterIndex, }: InputSquareProps) => {
  const { completed, clues, guesses, revealedCells, mistakes, focusedClueIndex, cursorIndex }
    = MorphologyStore.useState();

  const letter = guesses[clueIndex][letterIndex];
  const isFocused = clueIndex === focusedClueIndex && letterIndex === cursorIndex;

  // `completed` here catches the case of page reload subsequent to RevealAll, since we don't save
  // the fully revealedCells to the database at that point, just mark it revealed+completed.
  const isRevealed = completed || revealedCells[clueIndex][letterIndex];
  const isWrong = mistakes[clueIndex][letterIndex];

  const classes = `letterInput` +
   `${isFocused ? ' focused' : ''}` +
   `${isRevealed ? ' revealed' : ''}` +
   `${isWrong ? ' mistake' : ''}` +
   `${completed ? ' solved' : ''}`;

  return (
    <div className={classes} onClick={(e: any) => {
      MorphologyStore.update(s => {
        s.focusedClueIndex = clueIndex;
        s.cursorIndex = letterIndex;
      });
      // to stop the row onClick in Morphology.tsx from firing
      e.__isSelectingIndividualCell = true;
    }}>
      {isRevealed ? clues[clueIndex].solution[letterIndex] : letter}
    </div>
  );
};

export default InputSquare;